import { useEffect } from 'react';
import { triggerSync } from '../utils/autoSync';

const SYNC_INTERVAL_MS = 60_000; // 1分

/**
 * グローバル自動同期フック
 * - マウント時に即実行
 * - 60秒ごとに実行
 * - ネットワーク復帰（online イベント）時に実行
 */
export function useAutoSync() {
  useEffect(() => {
    // マウント時に即実行
    triggerSync();

    // 1分ごとに実行
    const timer = setInterval(() => {
      triggerSync();
    }, SYNC_INTERVAL_MS);

    // オフライン→オンライン復帰時に即実行
    const handleOnline = () => {
      triggerSync();
    };
    window.addEventListener('online', handleOnline);

    return () => {
      clearInterval(timer);
      window.removeEventListener('online', handleOnline);
    };
  }, []); // マウント時に一度だけ登録
}
